import * as React from "react";
import { connect } from "react-redux";
import { ErrorLevelDisplay } from "../../../../../store/Policies/Displays";
import { PolicyBusinessRuleViolation, ErrorLevel } from "../../../../../store/Policies/Types";
import { ThemeShadowSizes, ThemePaletteState } from "@vwpfs/mary-air-lib/theme/_Types";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Badge } from "@vwpfs/mary-air-lib/components/air/05-atoms/Badge";
import { RowData, Table, TableData } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { Card } from "@vwpfs/mary-air-lib/components/air/07-organisms/Card";

/**
 *
 */
interface OwnProps {
    errors: PolicyBusinessRuleViolation[];
}

/**
 *
 */
type Props = OwnProps;

/**
 *
 */
export class ErrorDetailComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }

    public render() {
        return (
            <Div theme={{ shadow: ThemeShadowSizes.TINY, paletteState: ThemePaletteState.WARNING }}>
                <Card title="Error log" collapsable defaultCollapsed={false}>
                    <Table
                        hasActions
                        data={{
                            columns: this.resultsData().columns,
                            rows: this.resultsData().rows,
                            sort: this.resultsData().sort,
                        }}
                    />
                </Card>
            </Div>
        );
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.errors.map((row, index) => ({
            id: row.id,
            data: [
                row.errorDescription,
                (
                    <Badge
                        key={`p-badge-${index}`}
                        theme={{
                            paletteState:
                                row.errorLevel === ErrorLevel.CRITICAL
                                    ? ThemePaletteState.DANGER
                                    : ThemePaletteState.WARNING,
                            shadow: ThemeShadowSizes.TINY,
                        }}
                    >
                        {ErrorLevelDisplay[row.errorLevel]}
                    </Badge>
                ),
            ],
        }));
    }

    /**
     *
     */
    private resultsData(): TableData {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Error description",
                },
                {
                    label: "Error level",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}

/**
 *
 */
export const ErrorDetail = connect(
    undefined,
    {},
)(ErrorDetailComp);
